import React, { useState, useEffect } from "react";
import { Switch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import ListSimulation from "../Pages/listSimulations";
import ClientData from "../Pages/clientData";
import WorkData from "../Pages/workData";
import HealthStatement from "../Pages/healthStatement";
import Beneficiaries from "../Pages/beneficiaries";
import AdditionalInfoPart1 from "../Pages/additionalInfoPart1";
import AdditionalInfoPart2 from "../Pages/additionalInfoPart2";
import VerifySimulation from "../Pages/verifySimulation";
import { OffLine } from "../Pages/wizard/OffLine";
import { ProtectedRoute } from "./privateRoute";
import { DetailPageRVEO } from "../Pages/wizard/DetailPageRVEO";

function NestedRouters({ path }) {
  const elrouter = useHistory();
  const channel = useSelector((state) => state.login.channel);
  const granted = useSelector((state) => state.login.granted);

  const [isInline, setisInline] = useState(true);
  useEffect(() => {
    if (navigator.onLine) {
      setisInline(true);
    }
    window.addEventListener("offline", function () {
      setisInline(false);
    });

    window.addEventListener("online", function () {
      setisInline(true);
    });

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    updateOnlineStatus();

    return () => window.removeEventListener("online", updateOnlineStatus);
  }, []);

  function updateOnlineStatus() {
    navigator.onLine
      ? console.log("online")
      : elrouter.push("/cotizaciones/sin-conexion");
  }
  return (
    <Switch>
      <ProtectedRoute
        exact
        path={path}
        component={ListSimulation}
        granted={granted}
        channel={channel}
      />
      <ProtectedRoute
        exact
        path={path + "/datos-cliente"}
        component={ClientData}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/datos-laborales"}
        component={WorkData}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/declaracion-de-salud"}
        component={HealthStatement}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/beneficiarios"}
        component={Beneficiaries}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/info-complementaria-1"}
        component={AdditionalInfoPart1}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/info-complementaria-2"}
        component={AdditionalInfoPart2}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/verificacion"}
        component={VerifySimulation}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/detalle"}
        component={DetailPageRVEO}
        channel={channel}
        granted={granted}
      />

      <ProtectedRoute
        exact
        path={"/cotizaciones/sin-conexion"}
        component={OffLine}
        channel={channel}
        granted={granted}
      />
    </Switch>
  );
}

//en este componente agregamos las rutas que corresponden a la ruta "/SIMULACIONES", de esta manera agregamos en el la siguiente ruta
// como es el ejempplo de "/cliente_data" .

export default NestedRouters;
